@if(dimension()) {
  <div class="mb-10 flex flex-col items-center">
    <h3 class="mb-2 text-center text-base font-bold">{{ dimension().name }}</h3>

    <app-cpru-survey-score-big
      [score]="dimension().score"
    ></app-cpru-survey-score-big>

    <p class="grey-2 text-base">
      <i>Länets snitt: {{ dimension().avgScore }}%</i>
    </p>

    @if(!opened()) {
      <div
        (click)="openQuestionsPanel()"
        class="cursor-pointer text-base font-bold text-duck-blue-2 hover:text-duck-blue-1"
      >Läs mer</div>
    }
  </div>
}

